"use strict";

exports.__esModule = true;
exports.default = noop;

// Does nothing
function noop() {}